<template>
  <v-app id="salesportal">
    <v-navigation-drawer app
        :color="color"
        dark
        width="200"
        permanent
        v-if="user"
    >
      <v-list-item>
         <v-list-item-content>
          <v-list-item-title data-qa-username>{{user.name}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list dense>
       <v-list-item
         v-for="item in items"
         :key="item.text"
         @click="switchDashboards(item.id)"
         link
       >
         <v-list-item-icon>
           <v-icon>{{ item.icon }}</v-icon>
         </v-list-item-icon>
          <v-list-item-content>
          <v-list-item-title data-qa-portal>{{ item.text }} Portal</v-list-item-title>
         </v-list-item-content>
       </v-list-item>
      </v-list>
   </v-navigation-drawer>
    <Header></Header>
    <v-content>
      <div v-if="!user">
        <v-col>
          <v-img
            :src="require('./assets/images/gp_logo_blue.png')"
            class="my-3"
            contain
            absolute
            min-height="250"
           max-height="350"
          />
        </v-col>
        <v-row class="text-center">
          <v-col class="mb-4">
            <v-btn class="ma-2" outlined :color="color" @click.stop="handleClick" data-qa-signin>
              <v-icon left>mdi-account</v-icon>
              Sign in
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <div v-else-if="this.goodToGo === true">
        <Dashboard :key="activeDashboard" v-bind:user="this.user" v-bind:dashboard-url="this.dashboardUrl" v-bind:dashboard-type="dashboardType"></Dashboard>
      </div>
      <div v-else-if="this.goodToGo === false && this.snackbar === true">
        <v-alert
          text
          prominent
          type="error"
        >
          {{ snackbarMessage }}
        </v-alert>
      </div>
    </v-content>
    <Footer></Footer>
  </v-app>
</template>

<script>
import Dashboard from './views/Dashboard'
import Header from './components/Header'
import Footer from './components/Footer'
export default {
  name: 'App',
  components: {
    Dashboard,
    Header,
    Footer
  },
  data: () => ({
    item: 1,
    items: [],
    error: false,
    color: '#109dce',
    timeout: 6000,
    goodToGo: false,
    dashboardType: 'sales',
    activeDashboard: '',
    salesPortalUrl: 'https://gopuff.looker.com/dashboards/632',
    brandPortalUrl: 'https://gopuff.looker.com/dashboards/830',
    snackbar: false,
    snackbarMessage: ''
  }),
  computed: {
    user () {
      let user = null
      if (this.$adal.isAuthenticated()) {
        user = {
          ...this.$adal.user,
          name: this.$adal.user.profile.name,
          accountIdentifier: this.$adal.user.profile.oid,
          profile: {}
        }
      }
      return user
    },
    dashboardUrl () {
      return this.activeDashboard
    }
  },
  created: async function () {
    if (this.user !== null) {
      this.user.profile = await this.getUserFromLooker(this.user.userName)
      if (this.user.profile.length !== 0) {
        const groups = this.user.profile[0].group_ids.filter(element => element === 11 || element === 12)
        if (groups.length === 2) {
          this.items.push({ id: 'sales', text: 'Sales', icon: 'mdi-sale' })
          this.items.push({ id: 'brand', text: 'Brand', icon: 'mdi-chart-timeline-variant' })
          this.activeDashboard = this.salesPortalUrl
        } else if (groups[0] === 12) {
          this.items.push({ id: 'sales', text: 'Sales', icon: 'mdi-sale' })
          this.activeDashboard = this.salesPortalUrl
        } else {
          this.items.push({ id: 'brand', text: 'Brand', icon: 'mdi-chart-timeline-variant' })
          this.activeDashboard = this.brandPortalUrl
          this.dashboardType = 'brand'
        }
        this.goodToGo = true
      } else {
        this.snackbar = true
        this.snackbarMessage = 'Your permissions have not been set up, please contact your brand rep!'
      }
    }
  },
  methods: {
    handleClick () {
      this.$adal.login()
    },
    async getUserFromLooker (userEmail) {
      return fetch(`/api/user/login/${userEmail}`)
        .then(response => response.json())
    },
    switchDashboards (itemsId) {
      this.dashboardType = itemsId
      if (this.dashboardType === 'sales') {
        this.activeDashboard = this.salesPortalUrl
      } else {
        this.activeDashboard = this.brandPortalUrl
      }
    }
  }
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
